module.exports = __webpack_public_path__ + "static/media/aboutHero.d96bc4c2.jpg";